"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var info_card_component_1 = __importDefault(require("../info-card/info-card.component"));
var InfoCards = function (props) {
  if (props.cards === undefined || props.cards.length <= 0) return null;
  var size = props.cards.length === 1 ? 'lg' : 'sm';
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: props.cards.map(function (infoCard) {
      var _a;
      return (0, jsx_runtime_1.jsx)(info_card_component_1.default, __assign({
        size: size
      }, infoCard), "".concat(infoCard.title, "-").concat((_a = infoCard.link) === null || _a === void 0 ? void 0 : _a.linkUrl));
    })
  });
};
exports.default = InfoCards;